import { useState } from "react";
import { Link } from "react-router";
import { useSitzung } from "../sitzung";
import { Karte } from "../ui/Karte";
import { Knopf } from "../ui/Knopf";
import s from "./seiten.module.css";
import { Laedt } from "../ui/Laedt";

function Rahmen({ titel, children }: { titel: string; children: React.ReactNode }) {
  return (
    <main className={s.anmeldenForm} style={{ minHeight: "100vh" }}>
      <div className={s.anmeldenKarte}>
        <Karte titel={titel}>{children}</Karte>
      </div>
    </main>
  );
}

export function KeinZugang({ email }: { email: string }) {
  const { abmelden } = useSitzung();
  return (
    <Rahmen titel="Kein Zugang zur App">
      <p>Mit {email || "dieser Adresse"} gibt es keinen aktiven Zugang zur obsn App. Wenn das nicht stimmt, frag im Vorstand nach.</p>
      <Knopf onClick={() => void abmelden()}>Abmelden</Knopf>
    </Rahmen>
  );
}

export function OhneDatenbank() {
  return (
    <Rahmen titel="Vorschau ohne Datenbank">
      <p>Diese Vorschau ist nicht mit einer Datenbank verbunden. Anmelden geht hier nicht. So bleiben echte Daten aus Vorschauen heraus.</p>
      <p className={s.klein}>Lokal mit Testdaten: siehe README, Abschnitt „Neuer Rechner bis zur laufenden App“.</p>
    </Rahmen>
  );
}

/** Server beim Start nicht erreichbar (BAUPLAN-PAKETE.md, Abschnitt 4.8). Die Anmeldung bleibt, beim Ereignis `online` lädt die App
 *  von selbst neu (sitzung.tsx). */
export function Offline() {
  const { neuLaden } = useSitzung();
  const [laeuft, setLaeuft] = useState(false);
  return (
    <Rahmen titel="Keine Verbindung">
      <p role="status">Die App erreicht den Server gerade nicht. Du bleibst angemeldet.</p>
      <Knopf
        art="primaer"
        disabled={laeuft}
        onClick={() => {
          setLaeuft(true);
          void neuLaden().finally(() => setLaeuft(false));
        }}
      >
        {laeuft ? "Einen Moment …" : "Neu versuchen"}
      </Knopf>
    </Rahmen>
  );
}

export function Laden() {
  return (
    <main className={s.anmeldenForm} style={{ minHeight: "100vh" }} aria-busy="true">
      <Laedt />
    </main>
  );
}

export function NichtGefunden() {
  return (
    <div className={s.stapel}>
      <div className={s.kopf}>
        <h1>Diese Seite gibt es nicht.</h1>
      </div>
      <p>
        Vielleicht ein alter Link. <Link to="/">Zur Startseite</Link>
      </p>
    </div>
  );
}

export function KeinRecht() {
  return (
    <div className={s.stapel}>
      <div className={s.kopf}>
        <h1>Dafür fehlt dir das Recht.</h1>
      </div>
      <p>
        Diese Seite ist nur für bestimmte Rollen. <Link to="/">Zur Startseite</Link>
      </p>
    </div>
  );
}
